'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n    ', ';\n  '], ['\n    ', ';\n  ']);

var _styledComponents = require('styled-components');

var _grid = require('./grid');

var _grid2 = _interopRequireDefault(_grid);

var _gridUnit = require('./gridUnit');

var _gridUnit2 = _interopRequireDefault(_gridUnit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function grid(opts) {
  return (0, _styledComponents.css)(_templateObject, function (_ref) {
    var theme = _ref.theme;
    return (0, _grid2.default)((0, _extends3.default)({ theme: theme }, opts));
  });
}

function gridUnit(opts) {
  return (0, _styledComponents.css)(_templateObject, function (_ref2) {
    var theme = _ref2.theme;
    return (0, _gridUnit2.default)((0, _extends3.default)({ theme: theme }, opts));
  });
}

grid.unit = gridUnit;

exports.default = grid;


//////////////////
// WEBPACK FOOTER
// ./~/styled-components-grid/dist/cjs/mixins/index.js
// module id = 707
// module chunks = 168707334958949